<div class="account-pages my-5 pt-5">
  <div class="container">
    <!-- Step Progress Indicator -->
    <div class="row justify-content-center mb-4">
      <div class="col-lg-10">
        <div class="card shadow-sm border-0" style="background: linear-gradient(135deg, #556ee6 0%, #6c81ec 100%);">
          <div class="card-body py-3 px-4">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div>
                <small class="text-white-50 text-uppercase fw-semibold">Onboarding Progress</small>
                <h6 class="mb-0 mt-1">
                  <span class="text-white">Step {{ currentStep }} </span>
                  <span class="text-white">of {{ totalSteps }}</span>
                </h6>
              </div>
              <div class="text-end">
                <span class="badge bg-white text-success font-size-12 px-3 py-2">
                  <i class="bx bxl-whatsapp me-1"></i> WhatsApp Setup
                </span>
              </div>
            </div>
            <div class="progress" style="height: 8px; border-radius: 10px; background-color: rgba(255, 255, 255, 0.2);">
              <div class="progress-bar bg-white" 
                   role="progressbar" 
                   [style.width.%]="progressPercentage"
                   [attr.aria-valuenow]="progressPercentage" 
                   aria-valuemin="0" 
                   aria-valuemax="100"
                   style="border-radius: 10px; transition: width 0.6s ease;">
              </div>
            </div>
            <div class="d-flex justify-content-between mt-2">
              <small class="text-white-50">
                <i class="bx bx-loader bx-spin me-1"></i>WhatsApp Connection
              </small>
              <small class="text-white-50 font-size-11">{{ progressPercentage }}% Complete</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <!-- Main Setup Card -->
      <div class="col-lg-6">
        <div class="card overflow-hidden shadow-sm border-0">
          <div class="bg-success">
            <div class="text-success text-center p-4">
              <div class="d-flex align-items-center justify-content-center">
                <i class="bx bxl-whatsapp font-size-32 text-white me-3"></i>
                <div class="text-start">
                  <h5 class="text-white font-size-20 mb-1">Connect WhatsApp</h5>
                  <p class="text-white-50 mb-0">Send messages to your members</p>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body p-4">
            <div class="p-3">
              @if (isLoading) {
                <div class="text-center py-5">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <p class="mt-2 text-muted">Loading WhatsApp account...</p>
                </div>
              } @else if (!whatsappAccount || whatsappAccount.status !== 'connected') {
                <!-- Not Connected - Show Setup -->
                <!-- Which number are you bringing?
                     Asked before Meta's dialog opens, because `featureType` is
                     fixed at FB.login and cannot change once the dialog is up.
                     Phrased as "where do you use it now" rather than by
                     platform: a church administrator knows which app is on
                     their phone, and does not know what a WABA is. -->
                @if (!numberRoute) {
                  <div class="text-center mb-4">
                    <div class="avatar-lg mx-auto mb-3">
                      <div class="avatar-title bg-soft-success text-success rounded-circle">
                        <i class="bx bxl-whatsapp font-size-24"></i>
                      </div>
                    </div>
                    <h5 class="mb-2">Where do you use this number now?</h5>
                    <p class="text-muted mb-0 font-size-13">
                      Pick the one that matches. It decides how we connect it, and it
                      can't be changed once we start.
                    </p>
                  </div>

                  <div class="d-grid gap-3">
                    <button type="button" class="route-choice" (click)="chooseRoute('new')">
                      <i class="bx bx-phone"></i>
                      <span class="route-choice-body">
                        <span class="route-choice-title">Nowhere yet</span>
                        <span class="route-choice-detail">
                          A new SIM, or a number that isn't on WhatsApp at all.
                          This is the simplest one.
                        </span>
                      </span>
                      <i class="bx bx-chevron-right route-choice-go"></i>
                    </button>

                    <button type="button" class="route-choice" (click)="chooseRoute('business-app')">
                      <i class="bx bx-mobile-alt"></i>
                      <span class="route-choice-body">
                        <span class="route-choice-title">On the WhatsApp Business app</span>
                        <span class="route-choice-detail">
                          The green business app on a phone, with your catalogue and
                          quick replies. Keep using it exactly as you do now — your
                          chats and contacts come across and nothing is deleted.
                        </span>
                      </span>
                      <i class="bx bx-chevron-right route-choice-go"></i>
                    </button>

                    <button type="button" class="route-choice" (click)="chooseRoute('personal')">
                      <i class="bx bxl-whatsapp"></i>
                      <span class="route-choice-body">
                        <span class="route-choice-title">On ordinary WhatsApp</span>
                        <span class="route-choice-detail">
                          The normal green WhatsApp everyone uses, not the business one.
                        </span>
                      </span>
                      <i class="bx bx-chevron-right route-choice-go"></i>
                    </button>

                    <button type="button" class="route-choice" (click)="chooseRoute('existing-waba')">
                      <i class="bx bx-link"></i>
                      <span class="route-choice-body">
                        <span class="route-choice-title">On another messaging platform</span>
                        <span class="route-choice-detail">
                          Someone already set this number up to send automated or bulk
                          WhatsApp messages — through another provider, or directly in
                          Meta Business Suite.
                        </span>
                      </span>
                      <i class="bx bx-chevron-right route-choice-go"></i>
                    </button>
                  </div>

                  <p class="text-muted font-size-13 mt-3 mb-0">
                    Not sure? Pick <strong>On ordinary WhatsApp</strong> — we'll tell you
                    if it needs something different.
                  </p>
                }

                @if (numberRoute === 'new') {
                  <h5 class="font-size-16 mb-3">What happens next</h5>
                  <ol class="text-muted font-size-13 ps-3 mb-3">
                    <li class="mb-2">A Facebook window opens. Sign in and follow it through.</li>
                    <li class="mb-2">Meta <strong>sends a code by text</strong> to the number
                        you're connecting. Type it into that window.</li>
                    <li class="mb-2">You choose a <strong>6-digit PIN</strong>. Write it down —
                        Meta asks for it again later and we can't recover it for you.</li>
                  </ol>
                  <h6 class="font-size-14 mb-2">Have these ready</h6>
                  <ul class="text-muted font-size-13 ps-3 mb-3">
                    <li class="mb-1">A Facebook login you can get into.</li>
                    <li class="mb-1">The phone with that number, to read the code.</li>
                    <li class="mb-1">A debit or credit card — Meta needs one before your
                        first message sends. You can add it afterwards.</li>
                    <li class="mb-1">About ten minutes.</li>
                  </ul>
                }

                @if (numberRoute === 'business-app') {
                  <h5 class="font-size-16 mb-3">What happens next</h5>
                  <ol class="text-muted font-size-13 ps-3 mb-3">
                    <li class="mb-2">A Facebook window opens. Choose
                        <strong>connect your existing WhatsApp Business account</strong>
                        and enter this number.</li>
                    <li class="mb-2">That window shows you a <strong>QR code and a short
                        code</strong>. Leave it open.</li>
                    <li class="mb-2">Open the <strong>WhatsApp Business app on your phone</strong>.
                        A new chat arrives from Meta with a
                        <strong>Connect to the Business Platform</strong> button. Tap it,
                        then either scan the QR code off your screen or type the short code in.</li>
                    <li class="mb-2">Say yes to bringing your chat history across, and you're done.</li>
                  </ol>
                  <p class="text-muted font-size-13 mb-3">
                    There's <strong>no text message and no PIN</strong> on this route —
                    tapping the button in your app is what proves the number is yours.
                  </p>

                  <h6 class="font-size-14 mb-2">Meta only allows this if your number</h6>
                  <ul class="text-muted font-size-13 ps-3 mb-3">
                    <li class="mb-1">is on the <strong>WhatsApp Business app</strong>,
                        version 2.24.17 or newer;</li>
                    <li class="mb-1">has been in real use for <strong>about a week</strong>;</li>
                    <li class="mb-1">has never been connected to the WhatsApp Business API —
                        if it has, Meta wants a month or two before it can be reused.</li>
                  </ul>
                  <div class="alert alert-warning border-0 font-size-13" role="alert">
                    If that option doesn't appear once you continue, the number hasn't met
                    one of these yet. Nothing is broken — come back when it has.
                  </div>
                }

                @if (numberRoute === 'personal') {
                  <div class="alert alert-warning border-0 font-size-13" role="alert">
                    <p class="mb-2">
                      A number can't be on ordinary WhatsApp and on a business platform at
                      the same time. To use this one here, you'd have to
                      <strong>delete its WhatsApp account first</strong> — which removes
                      those chats from the phone.
                    </p>
                    <p class="mb-0">
                      Most people use a different number instead, and keep their personal
                      one as it is.
                    </p>
                  </div>
                  <p class="text-muted font-size-13 mb-3">
                    If you'd rather use a separate number, go back and choose
                    <strong>Nowhere yet</strong>. If you're set on this one, continue and
                    Meta will walk you through removing it.
                  </p>
                }

                @if (numberRoute === 'existing-waba') {
                  <div class="alert alert-info border-0 font-size-13" role="alert">
                    <p class="mb-2">
                      A number that's already sending business messages somewhere else
                      can't be moved across by signing up — Meta's sign-up creates a new
                      connection, it can't take over one that exists.
                    </p>
                    <p class="mb-0">
                      We'll move it for you. It keeps working while we do.
                    </p>
                  </div>
                  <p class="text-muted font-size-13 mb-3">
                    Tell us the number and who it's with, and we'll take it from there.
                  </p>
                }

                @if (numberRoute) {
                  <div class="d-grid gap-2 mt-3">
                    @if (numberRoute === 'existing-waba') {
                      <button type="button" class="btn btn-primary btn-lg"
                              (click)="requestAssistedLink()">
                        <i class="bx bx-envelope me-1"></i> Ask us to move it
                      </button>
                    } @else {
                      <button type="button"
                              class="btn btn-success btn-lg waves-effect waves-light shadow-sm"
                              [disabled]="isConnecting"
                              (click)="numberRoute === 'business-app' ?
                                       connectExistingWhatsAppApp() : connectWhatsApp()"
                              style="padding: 12px; font-size: 16px;">
                        @if (isConnecting) {
                          <span><i class="bx bx-loader bx-spin me-2"></i>Connecting...</span>
                        } @else {
                          <span><i class="bx bxl-whatsapp me-2 font-size-18"></i><span class="fw-semibold">Continue to WhatsApp</span></span>
                        }
                      </button>
                    }

                    <button type="button" class="btn btn-link text-muted"
                            [disabled]="isConnecting" (click)="clearRoute()">
                      That's not my situation — go back
                    </button>
                  </div>
                }

                <div class="d-grid gap-2">
                  <button 
                    type="button" 
                    class="btn btn-outline-secondary waves-effect mt-3"
                    (click)="skip()">
                    Skip - I'll Set This Up Later
                  </button>
                </div>
              } @else {
                <!-- Connected - Show Account Details -->
                <div class="alert alert-success mb-4" role="alert">
                  <i class="bx bx-check-circle me-2"></i>
                  <strong>WhatsApp Business Account Connected</strong>
                </div>

                <!-- Phone Numbers -->
                <h5 class="mb-3">Connected Phone Numbers</h5>
                
                @if (whatsappAccount.phoneNumbers && whatsappAccount.phoneNumbers.length > 0) {
                  <div class="table-responsive">
                    <table class="table table-bordered table-hover align-middle mb-0">
                      <thead class="table-light">
                        <tr>
                          <th>Phone Number</th>
                          <th>Display Name</th>
                          <th>Quality Rating</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (phone of whatsappAccount.phoneNumbers; track phone.id) {
                          <tr>
                            <td>
                              <i class="bx bxs-phone me-2 text-success"></i>
                              <strong>{{ phone.displayPhoneNumber }}</strong>
                            </td>
                            <td>{{ phone.verifiedName }}</td>
                            <td>
                              @if (phone.qualityRating === 'GREEN') {
                                <span class="badge badge-soft-success">{{ phone.qualityRating }}</span>
                              } @else if (phone.qualityRating === 'YELLOW') {
                                <span class="badge badge-soft-warning">{{ phone.qualityRating }}</span>
                              } @else if (phone.qualityRating === 'RED') {
                                <span class="badge badge-soft-danger">{{ phone.qualityRating }}</span>
                              } @else {
                                <span class="badge badge-soft-secondary">{{ phone.qualityRating }}</span>
                              }
                            </td>
                            <td>
                              <span class="badge" [ngClass]="{ 'badge-soft-success': phone.isConnected, 'badge-soft-warning': !phone.isConnected }">
                                {{ phone.isConnected ? 'Connected' : 'Pending' }}
                              </span>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                } @else {
                  <div class="alert alert-warning">
                    <i class="bx bx-info-circle me-2"></i>
                    No phone numbers found. Please add a phone number in your WhatsApp Business Account.
                  </div>
                }

                <!-- What is actually left. The payment method used to be a
                     one-off dialog that vanished on dismissal, and the ownership
                     code and PIN were never mentioned here at all — they live on
                     a settings page this wizard did not point at. -->
                <div class="mt-4 mb-4">
                  <app-whatsapp-setup-checklist
                    [account]="whatsappAccount"
                    [context]="checklistContext">
                  </app-whatsapp-setup-checklist>
                </div>

                <!-- Continue Button -->
                <div class="d-grid mt-4">
                  <button 
                    type="button" 
                    class="btn btn-primary btn-lg waves-effect waves-light"
                    (click)="complete()">
                    <i class="bx bx-right-arrow-alt me-1"></i> Continue
                  </button>
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      <!-- Help & FAQ Section -->
      <div class="col-lg-6">
        <div class="card shadow-sm border-0">
          <div class="card-body p-4">
            <div class="d-flex align-items-center mb-4">
              <div class="avatar-sm me-3">
                <div class="avatar-title bg-soft-success text-success rounded">
                  <i class="bx bx-help-circle font-size-20"></i>
                </div>
              </div>
              <div>
                <h5 class="mb-0">Help & FAQ</h5>
                <small class="text-muted">Common questions answered</small>
              </div>
            </div>

            <div class="accordion" id="whatsappFaqAccordion">
              <div class="accordion-item">
                <h2 class="accordion-header" id="waFaqHeading1">
                  <button class="accordion-button fw-semibold" [class.collapsed]="openFaqIndex !== 0" type="button" (click)="toggleFaq(0)">
                    <i class="bx bx-whatsapp text-success me-2"></i>
                    Why connect WhatsApp Business?
                  </button>
                </h2>
                <div id="waFaqCollapse1" class="accordion-collapse collapse" [class.show]="openFaqIndex === 0">
                  <div class="accordion-body">
                    <p class="text-muted font-size-14 mb-0">
                      WhatsApp has over 2 billion users worldwide and offers higher engagement rates than email or SMS. 
                      By connecting your WhatsApp Business account, you can send
                      {{ hasPco ? 'automated, personalized' : 'personalized' }} messages to your
                      community members instantly.
                    </p>
                  </div>
                </div>
              </div>

              <div class="accordion-item">
                <h2 class="accordion-header" id="waFaqHeading2">
                  <button class="accordion-button fw-semibold" [class.collapsed]="openFaqIndex !== 1" type="button" (click)="toggleFaq(1)">
                    <i class="bx bx-briefcase text-primary me-2"></i>
                    What's a WhatsApp Business Account?
                  </button>
                </h2>
                <div id="waFaqCollapse2" class="accordion-collapse collapse" [class.show]="openFaqIndex === 1">
                  <div class="accordion-body">
                    <p class="text-muted font-size-14 mb-0">
                      A WhatsApp Business Account (WABA) is different from a regular WhatsApp account. It's designed for 
                      organizations and allows you to send template-based messages, access analytics, and integrate with 
                      platforms like Echo. If you haven't set one up yet, you can create one when you click "Connect WhatsApp Now" above.
                    </p>
                  </div>
                </div>
              </div>

              <div class="accordion-item">
                <h2 class="accordion-header" id="waFaqHeading3">
                  <button class="accordion-button fw-semibold" [class.collapsed]="openFaqIndex !== 2" type="button" (click)="toggleFaq(2)">
                    <i class="bx bx-dollar text-warning me-2"></i>
                    Are there any costs?
                  </button>
                </h2>
                <div id="waFaqCollapse3" class="accordion-collapse collapse" [class.show]="openFaqIndex === 2">
                  <div class="accordion-body">
                    <p class="text-muted font-size-14 mb-2">
                      Meta (Facebook) charges per message you send, based on the recipient's country
                      and the message category. Messages your customers send to you are always free.
                    </p>
                    <p class="text-muted font-size-14 mb-2">
                      When someone messages you first, you can reply in your own words for 24 hours
                      with no template and no approval wait. From 1 October 2026 Meta charges for
                      each of those replies, at the same rate as a utility message in your market;
                      before that date they are free.
                    </p>
                    <p class="text-muted font-size-14 mb-0">
                      Echo doesn't charge extra for WhatsApp integration or add any markup to the
                      cost per message. You can see rates and set monthly spending limits under
                      Organization &rsaquo; Messaging Pricing.
                    </p>
                  </div>
                </div>
              </div>

              <div class="accordion-item">
                <h2 class="accordion-header" id="waFaqHeading5">
                  <button class="accordion-button fw-semibold" [class.collapsed]="openFaqIndex !== 4" type="button" (click)="toggleFaq(4)">
                    <i class="bx bx-unlink text-warning me-2"></i>
                    Can I disconnect later?
                  </button>
                </h2>
                <div id="waFaqCollapse5" class="accordion-collapse collapse" [class.show]="openFaqIndex === 4">
                  <div class="accordion-body">
                    <p class="text-muted font-size-14 mb-0">
                      Yes! You can manage or disconnect your WhatsApp Business account at any time from Organization Settings. 
                      Your message history and templates will remain in Echo for reference.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
